export { default as BarChartIcon } from '@material-ui/icons/BarChart';
export { default as CalendarTodayIcon } from '@material-ui/icons/CalendarToday';
export { default as ChatIcon } from '@material-ui/icons/ChatOutlined';
export { default as CodeIcon } from '@material-ui/icons/Code';
export { default as DashboardIcon } from '@material-ui/icons/DashboardOutlined';
export { default as ErrorIcon } from '@material-ui/icons/ErrorOutline';
export { default as FolderIcon } from '@material-ui/icons/FolderOutlined';
export { default as ListAltIcon } from '@material-ui/icons/ListAlt';
export { default as LockOpenIcon } from '@material-ui/icons/LockOpenOutlined';
export { default as MailIcon } from '@material-ui/icons/MailOutlined';
export { default as PresentToAllIcon } from '@material-ui/icons/PresentToAll';
export { default as PeopleIcon } from '@material-ui/icons/PeopleOutlined';
export { default as PersonIcon } from '@material-ui/icons/PersonOutlined';
export { default as ReceiptIcon } from '@material-ui/icons/ReceiptOutlined';
export { default as SettingsIcon } from '@material-ui/icons/SettingsOutlined';
export { default as ViewModuleIcon } from '@material-ui/icons/ViewModule';
export { default as BurstModeOutlined } from '@material-ui/icons/BurstModeOutlined';
export { default as ContactsOutlined } from '@material-ui/icons/ContactsOutlined';
export { default as DashboardOutlined } from '@material-ui/icons/DashboardOutlined';
export { default as EventOutlined } from '@material-ui/icons/EventOutlined';
export { default as ExploreOutlined } from '@material-ui/icons/ExploreOutlined';
export { default as HomeOutlined } from '@material-ui/icons/HomeOutlined';
export { default as ListAltOutlined } from '@material-ui/icons/ListAltOutlined';
export { default as MessageOutlined } from '@material-ui/icons/MessageOutlined';
export { default as TimelineOutlined } from '@material-ui/icons/TimelineOutlined';
export { default as ToysOutlined } from '@material-ui/icons/ToysOutlined';
export { default as AssessmentOutlined } from '@material-ui/icons/AssessmentOutlined';
export { default as CheckBoxOutlineBlankOutlined } from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
export { default as CheckBoxOutlined } from '@material-ui/icons/CheckBoxOutlined';
export { default as RenewIcon } from '@material-ui/icons/Autorenew';
export { default as WatchIcon } from '@material-ui/icons/Watch';
export { default as DevicesOtherIcon } from '@material-ui/icons/DevicesOther';
export { default as DevicesIcon } from '@material-ui/icons/Devices';
export { default as ExitToAppIcon } from '@material-ui/icons/ExitToApp';
export { default as DirectionsRunIcon } from '@material-ui/icons/DirectionsRun';
export { default as FitnessCenterIcon } from '@material-ui/icons/FitnessCenter';
export { default as RefreshIcon } from '@material-ui/icons/Refresh';
export { default as FavoriteIcon } from '@material-ui/icons/Favorite';
export { default as DirectionsWalkIcon } from '@material-ui/icons/DirectionsWalk';
export { default as LocalHospitalIcon } from '@material-ui/icons/LocalHospital';
export { default as TranslateIcon } from '@material-ui/icons/Translate';
export { default as HotelIcon } from '@material-ui/icons/Hotel';
export { default as CloseIcon } from '@material-ui/icons/Close';
export { default as EditIcon } from '@material-ui/icons/Edit';
export { default as DeleteIcon } from '@material-ui/icons/Delete';
export { default as AddIcon } from '@material-ui/icons/Add';
export { default as InfoIcon } from '@material-ui/icons/Info';
export { default as ReportProblemIcon } from '@material-ui/icons/ReportProblem';
export { default as VolumeUpIcon } from '@material-ui/icons/VolumeUp';
export { default as VolumeOffIcon } from '@material-ui/icons/VolumeOff';
export { default as HomeIcon } from '@material-ui/icons/Home';
export { default as LocationOnIcon } from '@material-ui/icons/LocationOn';
export { default as WavesIcon } from '@material-ui/icons/Waves';
export { default as AdjustIcon } from '@material-ui/icons/Adjust';
export { default as OpenInNewIcon } from '@material-ui/icons/OpenInNew';;

export { default as Facebook } from './Facebook';
export { default as Google } from './Google';



const monitoring = require('../assets/icons/monitoring.svg');
 
 
 
 
  export default {
     'monitoring': monitoring,
      
 }